module.exports = function() {
  return new Worker(__webpack_public_path__ + "tree_worker.34ef9c4c.worker.js");
};